import { Typography } from "@mui/material";

export const parseBreakLine = (str: string) => {
  if (!str.includes("\n")) {
    return str;
  }
  const tempStrings = str.split("\n");
  return (
    <div>
      {tempStrings.map((str, index) => (
        <Typography
          variant="body1"
          key={`${str}-${
            // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
            index
          }`}
        >
          {str}
        </Typography>
      ))}
    </div>
  );
};
